
import Divider from '@mui/material/Divider';
import { CgTrack } from "react-icons/cg";
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useDeleteOrderMutation } from '../../../features/api/apiSlice';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useState } from 'react';

const Order = ({ order }) => {
    const [deleteOrder, { isLoading, isSuccess, isError }] = useDeleteOrderMutation();

    const handleDeleteCoupon = () => {
        deleteOrder(order._id)
    }

    useEffect(() => {
        if(isSuccess){
            toast.success("your order deleted", {
                position: "bottom-left",
            });
        }
        if(isError){
            toast.error("error!!!", {
                position: "bottom-left",
            });
        }
    }, [isSuccess, isError]);

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div className="pt-0 pl-3 pr-3 pb-0 my-3  bg-white  shadow">
            <div className="md:flex py-3">
                <div className='md:flex-grow md:flex gap-4'>
                    <h2 className='text-gray-700 py-2 px-4 bg-gray-200 rounded-full font-semibold'>{translate ? "Order ID" : "অডার আইডি:"} <span className='text-blue-500'> #{order?._id}</span></h2>
                    <p className='md:my-0 my-1 md:pt-1.5 text-gray-400 font-normal'>Order Placed: {order?.PlacedDate}</p>
                </div>
                <Link to={`/order/track-your-order/${order?._id}`}>
                    <button className='w-full md:w-auto bg-[#FF9800] px-4 py-2 rounded-full font-semibold text-white flex focus:outline-none'><CgTrack className='h-full mr-2 text-xl' /> {translate ? "TRACK ORDER" : "অডার ট্রেক করুন"}</button>
                </Link>
            </div>

            {order?.itemIds.map((item, index) => (
                <div key={index}>
                    <Divider />
                    <div className="grid grid-cols-10 py-4 md:py-1 gap-2">
                        <div className="md:col-span-4 col-span-10 grid grid-cols-3 gap-2">
                            <div className="col-span-1">
                                <img className='object-cover rounded-md bg-gray-100' src={item?.img} alt="" />
                            </div>
                            <div className="col-span-2 h-full grid content-center">
                                <h3 className='text-md md:mb-2 md:text-lg font-semibold font-poppins'>{item?.name.length > 32 ? item?.name.substring(32, 0) + ".." : item?.name}</h3>
                                <p className='text-md md:mb-2.5 text-gray-400'>Qty: {item?.quantity}</p>
                                <p className='text-lg text-gray-800 font-semibold'>BDT: {item?.total}</p>
                            </div>
                        </div>
                        <div className="md:col-span-3 col-span-5">
                            <div className="h-full w-full grid content-center justify-center">
                                <p className="text-gray-400 text-xs">Status</p>
                                <h3 className="text-md font-semibold text-[#F8A01B]">In - {order?.progressStatus}</h3>
                            </div>
                        </div>
                        <div className="md:col-span-3 col-span-5 grid content-center justify-center">
                            <p className="text-xs text-gray-400">Delivery Expected by:</p>
                            <p className="text-md font-extrabold font-poppins">{order?.deliveryExpectedDate}</p>
                        </div>
                    </div>
                </div>
            ))}

            <div className="md:flex md:gap-2 border-t w-full">
                <div className="md:border-r">
                    <h3 onClick={handleDeleteCoupon} className="md:text-inherit text-sm truncate md:py-3 py-1 px-3 uppercase font-medium cursor-pointer"><CloseIcon /> cancel order</h3>
                </div>
                <div className="flex gap-2 w-full">
                    <div className="md:text-inherit text-sm grow md:py-3 py-1 px-3 text-gray-400 uppercase">
                        {/* {order?.paymentStatus} */}
                        {order?.paidStatus === 'paid' ?
                            <p className='w-14 bg-green-500 py-1 text-center text-white font-semibold rounded text-sm'>{order?.paidStatus}</p>
                            :
                            <p className='w-36 bg-[#58B9D6] py-1 text-center text-white font-semibold rounded text-sm'>{"cash on delivery"}</p>
                        }
                    </div>
                    <div className="md:text-inherit text-sm flex-none md:py-3 py-1 px-3 font-extrabold text-md font-poppins">Total BDT. {order?.totalPrice}</div>
                </div>
            </div>
        </div>
    );
};

export default Order;